
import SystemConstants from './../constants/SystemConstants';
import assign from 'object-assign';
import AppDispatcher from './../flux/AppDispatcher';
import NodeEvents from 'events';
var EventEmitter = NodeEvents.EventEmitter;

var CHANGE_EVENT = 'system.change';
var _messages: IMessage = {},
    _messageCount: number = 0,
    _messageIndex: number = 0,
    _actionInProgress: { [id: string]: boolean } = {},
    _displayPrint: boolean = false,
    _printOptions: { [id: string]: string } = _getDefaultPrintOptions(),
    _disableShare = false;

function _getDefaultPrintOptions() {
    return {
        'orientation': 'portrait',
        'paper':'letter'
    };
}

function beginAction(action: string) {
    _actionInProgress[action] = true;
}

function endAction(action: string) {
    _actionInProgress[action] = false;
}

function addMessage(type: SystemConstants.MessageType, msgObj: IMessageObject) {
    
    for (var msg in _messages) {
        if (_messages[msg].msgObj.message === msgObj.message) {
            return false;
        }
    }
    
    var msgNum = _messageIndex++;
    var id = Math.random() + msgNum;
    //Hack because of the stupid enum typing.
    (_messages as any)[id] = {
        type: type,
        msgObj: msgObj
    };
    _messageCount++;

    return true;
}

function removeMessage(key: string) {
    if (_messages[key]) {
        delete _messages[key];
        _messageCount--;
    }
}

function handleShareStatus(status: boolean) {
    var container = document.getElementById('ihdr-share-list');
    if (container) {
        if (status) {
            // Disabled
            container.className = container.className.replace('disabled', '').trim() + ' disabled';
        } else {
            container.className = container.className.replace('disabled', '').trim()
        }
    }
}

var SystemStore: ISystemStore = assign({}, EventEmitter.prototype, {
    getMessages() {
        return _messages;
    },
    getMessageCount() {
        return _messageCount;
    },
    isActionInProgress(action: string) {
        return _actionInProgress[action] == true;
    },
    getDisplayPrint() {
        return _displayPrint;
    },
    getPrintOptions() {
        return _printOptions;
    },
    getIsShareButtonDisabled() {
        return _disableShare;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

AppDispatcher.get(SystemConstants.Internal.DISPATCHER_NAME).register(function (payload: any) {
    switch (payload.actionType) {
        case SystemConstants.Action.MESSAGE_DISPLAY:
            if (addMessage(payload.type, payload.msgObj)) {
                break;
            } else {
                return;
            }
        case SystemConstants.Action.MESSAGE_REMOVE:
            removeMessage(payload.key);
            break;
        case SystemConstants.Action.ACTION_IN_PROGRESS:
            beginAction(payload.action);
            break;
        case SystemConstants.Action.ACTION_COMPLETED:
            endAction(payload.action);
            break;
        case SystemConstants.Action.MESSAGE_CLEAR_ALL:
            var keys = Object.keys(_messages);

            if (keys.length === 0) {
                return true;
            }

            for (var i in keys) {
                removeMessage(keys[i]);
            }
            break;
        case SystemConstants.Action.DISPLAY_PRINT:
                _displayPrint = payload.display;
                break;
        case SystemConstants.Action.PRINT_OPTION_UPDATED:
            _printOptions[payload.name] = payload.value;
            break;
        case SystemConstants.Action.DISABLE_SHARE:
            _disableShare = payload.data;
            handleShareStatus(payload.data);
            return true;
        default: return true;
    }

    SystemStore.emitChange();

    return true;
});

export default SystemStore;